import { QUERY_STATUS, QueryStatusType } from "#constants";
import FormService from "#services/FormService";
import { FormCategoryType, FormSchemaType } from "@validereinc/domain";
import { useEffect, useState } from "react";

// IMPROVE: all functions in this file need to be deleted
/** @deprecated use react query patterns instead */
export function useFormSchemas(): [FormSchemaType[], string] {
  const [formSchemas, setFormSchemas] = useState([]);
  const [status, setStatus] = useState<QueryStatusType>(QUERY_STATUS.LOADING);

  useEffect(() => {
    FormService.listFormSchemas({})
      .then(({ data: { data } }) => {
        setFormSchemas(data);
        setStatus(QUERY_STATUS.SUCCESS);
      })
      .catch(() => {
        setStatus(QUERY_STATUS.ERROR);
      });
  }, []);

  return [formSchemas, status];
}

/** @deprecated use react query patterns instead */
export function useFormCategories({
  relatedEntityId,
  relatedEntityType,
}: {
  relatedEntityId?: string;
  relatedEntityType?: string;
} = {}) {
  const [formCategories, setFormCategories] = useState<FormCategoryType[]>([]);
  const [status, setStatus] = useState<QueryStatusType>(QUERY_STATUS.LOADING);

  useEffect(() => {
    FormService.listFormCategories({
      relatedEntityId,
      relatedEntityType,
    } as any)
      .then(({ data: { data } }) => {
        setFormCategories(data);
        setStatus(QUERY_STATUS.SUCCESS);
      })
      .catch(() => {
        setStatus(QUERY_STATUS.ERROR);
      });
  }, []);

  return [formCategories, status] as [FormCategoryType[], QueryStatusType];
}
